<div class="participant-list">
  <div appParticipantListFluidMaxHeight class="participant-list__content" tabindex="4">
    @for (packageUser of packageUsers$ | async; track packageUser) {
      <app-card
        backgroundStyle="{{ isMobile ? null : 'secondary' }}"
        class="participant-card"
        >
        <div class="participant-card__content">
          @if (!!packageUser.name) {
            <h3 class="participant-card__name" data-private>
              {{ packageUser.name }}
            </h3>
          }
          <p class="participant-card__role">{{ packageUser.role | role }}</p>
          @if (packageUser.isLoaded) {
            <mat-progress-bar
              aria-label="Participant Check In Progress"
              class="rkt-ProgressBar participant-card__progress"
              color="primary"
              mode="determinate"
              [value]="packageUser.progress"
              >
            </mat-progress-bar>
            <p class="participant-card__status">
              {{ packageUser.status | currentStatus }}
              @if (isSigningAgent() && packageUser.role !== signingAgentRoleCode) {
                <app-participant-list-timer
                  [seconds]="packageUser.secondsSinceLastAction"
                  [status]="packageUser.status"
                ></app-participant-list-timer>
              }
            </p>
          } @else {
            <app-skeleton-text></app-skeleton-text>
            <app-skeleton-text width="med"></app-skeleton-text>
          }
        </div>
      </app-card>
    }
  </div>
</div>
